import type { AuthorTitle } from './types';
import { cn } from '@skybeam/shared-utils/classnames/cn';

const formatDate = (date?: string | null) =>
  date ? `${date.slice(0, 10)}` : '';
const formatTimeToRead = (time?: number | null) =>
  time ? ` • ${time} min to read` : '';

export default function Author({
  author,
  onDarkBackground,
  publishedAt,
  timeToRead,
  twoLines = false,
}: AuthorTitle & { onDarkBackground?: boolean; twoLines?: boolean }) {
  return (
    <div
      data-test="latest-resources-card-author"
      data-test-author
      className={cn(
        'desktop:pt-8 pt-2.5 pb-2',
        twoLines ? 'flex flex-col py-0' : 'flex items-center gap-x-1',
        onDarkBackground ? 'text-[#CDDFFD]' : 'text-sm text-blue-500',
      )}
    >
      <p
        data-test="latest-resources-card-author-name"
        className={cn(
          twoLines && 'text-[0.875rem] leading-normal font-semibold text-black',
        )}
      >
        {author}
      </p>
      <p
        data-test="latest-resources-card-author-meta"
        className={cn(
          twoLines && 'text-[0.875rem] leading-normal',
          onDarkBackground ? 'text-[#CDDFFD]' : 'text-blue-500',
        )}
      >
        {twoLines ? '' : publishedAt && ' • '}
        {formatDate(publishedAt)}
        {formatTimeToRead(timeToRead)}
      </p>
    </div>
  );
}
